import { Component, inject, input, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ThemeService } from '../../../core/services/theme.service';
import { IconComponent } from '../../icons/icon.component';
import { ToggleComponent } from '../ui/toggle/toggle.component';

@Component({
  standalone: true,
  selector: 'app-theme-toggle',
  imports: [CommonModule, IconComponent, ToggleComponent],
  templateUrl: './theme-toggle.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: []
})
export class ThemeToggleComponent {
  @Input() variant: 'button' | 'toggle' = 'toggle';
  @Input() buttonClass: string = '';
  readonly themeService = inject(ThemeService);
  // themeService = inject(ThemeService);

  currentTheme = this.themeService.getTheme();

  toggleTheme(isChecked: boolean): void {
    this.themeService.setTheme(isChecked ? 'dark' : 'light');
  }
}
